<template>
    <div>
        <el-dialog class="dialogDiv" :close-on-click-modal="false" :modal-append-to-body='false' :title="dialogTitle" :visible.sync="foodDialogVisible" :before-close="handleCloseDialog">
            <el-form :model="foodAdd" :rules="dataRules" ref="foodAdd" class="ml20 mr20" label-position="right" label-width="100px">
                <el-form-item label="菜品分类" prop="foodType">
                    <el-select class="w120" v-model="foodAdd.foodType" placeholder="请选择菜品分类" @change="foodTypeSel">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="菜品名称" prop="foodName">
                    <el-input v-model="foodAdd.foodName" placeholder="请输入菜品名称" :maxlength="10"></el-input>
                </el-form-item>
                <el-form-item label="食材用料" prop="foodMaterials">
                    <el-input v-model="foodAdd.foodMaterials" placeholder="请输入食材用料" :maxlength="30"></el-input>
                </el-form-item>
                <el-form-item label="封面图片" prop="imgFile">
                    <div class="uploadPic">
                        <img-upload :echoFileId="echoFileId" @getImgFile="getImgFile"></img-upload>
                    </div>
                </el-form-item>
            </el-form>
            <div class="footer">
                <el-button @click="cancle" round>关闭</el-button>
                <el-button type="primary" @click="submit('foodAdd')" round>保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {enumList} from '@/utils/enumList'
import ImgUpload from '@/components/ImgUpload'
import * as foodApi from '@/api/food'
export default {
    name: 'FoodDialog',
    components: {
        ImgUpload
    },
    data() {
        return {
            dialogTitle: '添加菜品',
            dialogVisible: false,
            options: [],
            foodAdd: {
                foodType: '',
                foodName: '',
                foodMaterials: '',
                imgFile: null
            },
            echoFileId: '',
            dataRules: {
                foodType: [
                    { required: true, message: '请选择菜品分类', trigger: 'change' }
                ],
                foodName: [
                    { required: true, message: '请输入菜品名称', trigger: 'blur' }
                ],
                foodMaterials: [
                    { message: '请输入食材用料', trigger: 'blur' }
                ],
                imgFile: [
                    { required: this.foodData.type === 'isAdd', message: '请选择要上传的封面图片', trigger: 'blur' }
                ]
            }
        }
    },
    props: {
        foodDialogVisible: {
            required: true,
            type: Boolean
        },
        foodData: {
            type: Object,
            required: true
        }
    },
    methods: {
        foodTypeSel(val) {

        },
        getImgFile(file) {
            if(!file) {
                this.foodAdd.imgFile = null;
            } else {
                this.foodAdd.imgFile = file.raw;
            }
        },
        submit(foodAdd) {
            this.$refs[foodAdd].validate((valid) => {
                if (valid) {
                    let formData = new FormData();
                    formData.append('type', this.foodAdd.foodType)
                    formData.append('name', this.foodAdd.foodName)
                    formData.append('foodMaterials', this.foodAdd.foodMaterials)
                    formData.append('file', this.foodAdd.imgFile)
                    formData.append('uploadFileTypeEnum', 'IMAGE')
                    if(this.foodData.type === 'isAdd') {
                        foodApi.categoryAdd(formData).then(r => {
                            if(r.code === 200) {
                                this.$message.success('添加成功!')
                                this.$parent.getFoodList();
                                this.handleCloseDialog();
                            }
                        }).catch(e => {})
                    } else {
                        formData.append('id', this.foodData.data.id)
                        foodApi.categoryEdit(formData).then(r => {
                            if(r.code === 200) {
                                this.$message.success('编辑成功!')
                                this.$parent.getFoodList();
                                this.handleCloseDialog();
                            }
                        }).catch(e => {})
                    }
                    
                };
            });
        },
        cancle() {
            this.handleCloseDialog();
        },
        handleCloseDialog() {
            this.$emit('closeFoodDialog');
        }
    },
    mounted() {
        let obj = enumList.foodType;
        let propertys = [];
        let result = Object.keys(obj).sort().map((el) => {
            let propertysItem = {'value': el, 'label': obj[el]};
            propertys.push(propertysItem);
        });
        this.options = propertys;
        if(this.foodData.type === 'isAdd') {
            this.foodAdd === {}
        } else if(this.foodData.type === 'isEdit') {
            this.foodAdd.foodName = this.foodData.data.name
            this.foodAdd.foodType = this.foodData.data.type
            this.foodAdd.foodMaterials = this.foodData.data.foodMaterials
            this.echoFileId = this.foodData.data.fileUrl
        }

    }
}
</script>

<style lang="scss" scoped>
        .uploadPic {
            width: 180px;
            display: inline-block;
            margin-bottom: 30px;
            color: #33393F;
            p {
                width: 360px;
                color: #8A96A1;
            }
        }
    .footer {
        margin-top: 20px;
        text-align: right;
    }
</style>